/** ч.1340: стани фіскалізації (чек, повернення, Z-звіт) людською мовою — каса
 * показувала сирі коди «pending», «demo». */
export const FISCAL_STATUS_UK: Record<string, string> = {
  not_fiscalized: 'не фіскалізовано',
  pending: 'в очікуванні',
  fiscalized: 'фіскалізовано',
  failed: 'помилка',
  demo: 'демо-режим (у ДПС не передано)',
};

export const fiscalStatusUk = (s?: string | null) =>
  (s ? FISCAL_STATUS_UK[s] ?? s : '—');
